"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldPolyfill = void 0;
function shouldPolyfill() {
    return typeof Intl === 'undefined' || !('RelativeTimeFormat' in Intl);
}
exports.shouldPolyfill = shouldPolyfill;
